import Ajv from "ajv";
import { getQuoteResponseSchema, getCheckoutResponseSchema, pricingResponseSchema } from "../../../schemas/group_travel/PricingResponse";

const ajv = new Ajv();

export const validateCheckoutResponse = ajv.compile(getCheckoutResponseSchema);
export const validateCreateQuoteResponse = ajv.compile(getQuoteResponseSchema);
export const validatePricingResponse = ajv.compile(pricingResponseSchema);
